(function() {
  function initCollectionFaq() {
    var descEl = document.getElementById('mjs-desc') || document.getElementById('mjs-coll-desc');
    if (!descEl) return;
    if (descEl.dataset.faqProcessed === 'true') return;
    descEl.dataset.faqProcessed = 'true';

    var wrapper = descEl.closest('.mjs-collection__desc-wrap') || descEl.closest('.mjs-collection__description-wrapper') || descEl.parentElement;
    if (!wrapper) return;

    var children = Array.from(descEl.querySelectorAll('h2, h3, h4, p, ul, ol'));
    var descParts = [];
    var faqParts = [];
    var inFaq = false;
    var currentQ = null;

    children.forEach(function(el) {
      var tagName = el.tagName.toLowerCase();
      var text = el.textContent.trim();

      if ((tagName === 'h2' || tagName === 'h3' || tagName === 'h4') && 
          (text.includes('?') || text.toLowerCase().includes('faq'))) {
        inFaq = true;
        if (text.toLowerCase().includes('faq') && !text.includes('?')) {
          return;
        }
        if (currentQ) {
          faqParts.push(currentQ);
        }
        currentQ = { question: text, answer: '' };
      } else if (inFaq && currentQ && (tagName === 'p' || tagName === 'div' || tagName === 'ul' || tagName === 'ol')) {
        currentQ.answer += el.outerHTML;
      } else if ((tagName === 'h2' || tagName === 'h3' || tagName === 'h4') && inFaq) {
        if (currentQ) {
          faqParts.push(currentQ);
          currentQ = null;
        }
        if (text.includes('?')) {
          currentQ = { question: text, answer: '' };
        } else {
          inFaq = false;
          descParts.push(el);
        }
      } else if (!inFaq) {
        descParts.push(el);
      }
    });

    if (currentQ) faqParts.push(currentQ);
    if (faqParts.length === 0) return;

    descEl.innerHTML = '';
    descParts.forEach(function(el) {
      descEl.appendChild(el.cloneNode ? el.cloneNode(true) : el);
    });

    if (descEl.scrollHeight > 100) {
      descEl.classList.add('mjs-coll-desc-collapsed');
      var readBtn = document.createElement('button');
      readBtn.className = 'mjs-coll-read-more-btn';
      readBtn.textContent = 'READ MORE';
      readBtn.addEventListener('click', function() {
        if (descEl.classList.contains('mjs-coll-desc-collapsed')) {
          descEl.classList.remove('mjs-coll-desc-collapsed');
          readBtn.textContent = 'READ LESS';
        } else {
          descEl.classList.add('mjs-coll-desc-collapsed');
          readBtn.textContent = 'READ MORE';
        }
      });
      wrapper.appendChild(readBtn);
    }

    var oldReadMore = document.getElementById('mjs-read-more');
    if (oldReadMore) oldReadMore.style.display = 'none';
    var showMore = document.getElementById('show-more');
    if (showMore) showMore.style.display = 'none';
    var showLess = document.getElementById('show-less');
    if (showLess) showLess.style.display = 'none';

    var faqContainer = document.createElement('div');
    faqContainer.className = 'mjs-coll-faq';
    faqContainer.style.marginTop = '60px';
    faqContainer.style.marginBottom = '40px';
    faqContainer.style.maxWidth = '1200px';
    faqContainer.style.marginLeft = 'auto';
    faqContainer.style.marginRight = 'auto';
    faqContainer.style.padding = '0 40px';

    var faqTitle = document.createElement('h3');
    faqTitle.className = 'mjs-coll-faq__title';
    faqTitle.textContent = 'Frequently Asked Questions';
    faqContainer.appendChild(faqTitle);

    faqParts.forEach(function(faq) {
      var item = document.createElement('div');
      item.className = 'mjs-coll-faq__item';

      var question = document.createElement('button');
      question.className = 'mjs-coll-faq__question';
      question.innerHTML = '<span>' + faq.question + '</span><span class="mjs-coll-faq__icon"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg></span>';

      var answer = document.createElement('div');
      answer.className = 'mjs-coll-faq__answer';
      var answerInner = document.createElement('div');
      answerInner.className = 'mjs-coll-faq__answer-inner';
      answerInner.innerHTML = faq.answer;
      answer.appendChild(answerInner);

      question.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        faqContainer.querySelectorAll('.mjs-coll-faq__item.is-open').forEach(function(openItem) {
          openItem.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });

      item.appendChild(question);
      item.appendChild(answer);
      faqContainer.appendChild(item);
    });

    // Move FAQ to bottom of collection page, right before footer
    var mainSection = document.querySelector('.mjs-collection') || document.querySelector('main') || document.querySelector('[data-section-type]');
    if (mainSection) {
      mainSection.appendChild(faqContainer);
    } else {
      // Fallback: insert at the end of the main content area
      var mainContent = document.getElementById('MainContent') || document.querySelector('main');
      if (mainContent) {
        mainContent.appendChild(faqContainer);
      } else {
        wrapper.parentNode.insertBefore(faqContainer, wrapper.nextSibling);
      }
    }
    console.log('MJS FAQ accordion created with ' + faqParts.length + ' items');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCollectionFaq, 800);
    });
  } else {
    setTimeout(initCollectionFaq, 800);
  }
})();